import { render, staticRenderFns } from "./WelcomeLearningSystem.vue?vue&type=template&id=4d906dba"
import script from "./WelcomeLearningSystem.vue?vue&type=script&lang=js"
export * from "./WelcomeLearningSystem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports